import store from "../store";
import { apiDomain } from "./config";
import { isSmallerDevice } from "./helpers";

export default {
  app_url() {
    return apiDomain
  },

  asset(url) {
    return this.app_url() + '/' + url.replace(/^\/+|\/+$/g, '');
  },

  api_url(path = '') {
    return store.state.apiUrl + '/' + path.trim('/')
  },

  api_auth_url(path = '') {
    return store.state.apiUrl + '/auth/' + path.trim('/')
  },


  range: function(start, end) {
    return Array(end - start + 1).fill().map((_, idx) => start + idx)
  },


  isSmallerDevice(minWidth = 1055) {
    return isSmallerDevice(minWidth);
  },
}